module.exports = __webpack_public_path__ + "img/export-white.004800a3.svg";